module.exports = __webpack_public_path__ + "img/3.bf0def34.png";